<template>
	<aside class="main">
		<div class="form">
			<div class="form-row">
				<fieldset>
					<input placeholder="First Name*"
					       type="text"
					       tabindex="1"
					       required
					       autofocus
					       :class="{'error': !validate.firstName}"
					       @focus="validate.firstName = true"
					       v-model="form.firstName">
				</fieldset>
				<fieldset>
					<input placeholder="Last Name*"
					       type="text"
					       tabindex="2"
					       required
					       :class="{'error': !validate.lastName}"
					       @focus="validate.lastName = true"
					       v-model="form.lastName">
				</fieldset>
			</div>
			<div class="form-row">
				<fieldset>
					<input placeholder="Email Address*"
					       type="email"
					       tabindex="3"
					       required
					       :class="{'error': !validate.emailAddress}"
					       @focus="validate.emailAddress = true"
					       v-model="form.emailAddress">
				</fieldset>
				<fieldset>
					<input placeholder="Verify Email Address*"
					       type="email"
					       tabindex="3"
					       required
					       class="emailAddressVerify"
					       v-model="form.emailAddressVerify">
				</fieldset>
				<fieldset>
					<input placeholder="Phone Number*"
					       type="tel"
					       tabindex="4"
					       required
					       :class="{'error': !validate.phoneNumber}"
					       @focus="validate.phoneNumber = true"
					       v-model="form.phoneNumber">
				</fieldset>
			</div>
			<textarea placeholder="How can we help you?"
			          rows="5"
			          :class="{'error': !validate.message}"
			          @focus="validate.message = true"
			          v-model="form.message"/>

			<fieldset class="checkbox mt-4">
				<input type="checkbox" id="agreement" v-model="accept"/>
				<label for="agreement">By checking this box I agree to I agree to receive SMS from Beltone Alliance. Standard text messaging rates apply.  I can opt out at any time. </label>
			</fieldset>

			<!-- reCAPTCHA widget -->
			<!--<div class="recaptcha-row">
				<div class="g-recaptcha"
				     ref="recaptcha"/>
			</div>-->
			<label v-if="!recaptchaSuccess" class="recaptcha-error">Please check the "I'm not a robot" box to continue</label>
		</div>

		<div class="footer-actions">
			<button
					class="btn-beltone xl"
					:class="{ disabled: !accept }"
					@click="submit"
			>
				Submit
			</button>
		</div>
	</aside>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Services from "../mixins/services";

export default {
	mixins: [Services],
	props: ["clinicUrl"],
	data() {
		return {
			ready: false,
			accept: false,
			validate: {
				firstName: true,
				lastName: true,
				emailAddress: true,
				phoneNumber: true,
				message: true,
			},
			form: {
				firstName: "",
				lastName: "",
				emailAddress: "",
				emailAddressVerify: "",
				phoneNumber: "",
				message: "",
				clinicUrl: "",
				digitalLeadType: "ContactUs",
			},
			recaptchaSiteKey: "6Le-5TIrAAAAAPx8Rmyk5V42XLxrp8_TBXO9XLog",
			recaptchaResponse: '',
			recaptchaRendered: false,
			recaptchaSuccess: true,
		};
	},
	computed: mapState({
		clientToken: (state) => state.ClientToken.clientToken,
	}),
	methods: {
		...mapActions("ClientToken", { getClientToken: "getClientToken" }),
		...mapActions("FormContactUs", { postSubmitForm: "postSubmitForm" }),
		onCaptchaVerified(response) {
			this.recaptchaSuccess = true;
			this.recaptchaResponse = response;
		},
		onCaptchaExpired() {
			this.recaptchaSuccess = false;
			this.recaptchaResponse = null;
		},
		submit() {
			this.recaptchaSuccess = true;

			if (!this.accept || !this.validation()) return;

			let _data = { ...this.form };
			["utm_source", "utm_medium", "utm_campaign", "utm_content", "referrer_url"].forEach(
					(key) => {
						const val = sessionStorage.getItem(key);
						if (val) _data[key.charAt(0).toUpperCase() + key.slice(1)] = val;
					}
			);

			_data.recaptchaToken = this.recaptchaResponse;
			_data.pageLoadedAtUtc = window.iframes?.pageLoadedAtUtc || null;

			this.postSubmitForm({
				data: _data,
				ClientToken: this.clientToken,
				cb: () => {
					this.goToThankYouPage();
				},
			});
		},

		validation() {
			let valid = true;
			const emailRegex =
					/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
			const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

			//if (!this.recaptchaResponse) {
			//	this.recaptchaSuccess = false;
			//	return false;
			//}

			if (this.form.firstName.trim().length === 0) {
				this.validate.firstName = false;
				valid = false;
			}
			if (this.form.lastName.trim().length === 0) {
				this.validate.lastName = false;
				valid = false;
			}
			if (!emailRegex.test(this.form.emailAddress)) {
				this.validate.emailAddress = false;
				valid = false;
			}
			if (!phoneRegex.test(this.form.phoneNumber)) {
				this.validate.phoneNumber = false;
				valid = false;
			}
			if (this.form.message.trim().length === 0) {
				this.validate.message = false;
				valid = false;
			}

			return valid;
		},

		goToThankYouPage() {
			window.top.location.href = `${document.referrer}/thank-you-contact-us/`;
		},
	},

	mounted() {
		const checkRecaptcha = () => {
			if (window.grecaptcha && window.grecaptcha.render && this.$refs.recaptcha) {
				if (!this.recaptchaRendered) {
					console.log("Rendering reCAPTCHA...");
					window.grecaptcha.render(this.$refs.recaptcha, {
						sitekey: this.recaptchaSiteKey,
						callback: this.onCaptchaVerified,
						'expired-callback': this.onCaptchaExpired
					});
					this.recaptchaRendered = true;
				}
			} else {
				console.log("Waiting for reCAPTCHA or ref to be ready...");
				setTimeout(checkRecaptcha, 500);
			}
		};

		checkRecaptcha();
	},
	created() {
		this.getClientToken({
			cb: () => {
				this.form.clinicUrl = this.clinicUrl;
				this.ready = true;

				setInterval(() => {
					const height = document.body.offsetHeight;
					parent.postMessage("resize::formContactUs" + height, "*");
				}, 1000);
			},
		});
	},
};
</script>